import { render } from "./Set-Mesh.vue?vue&type=template&id=1ab83f94"
import script from "./Set-Mesh.vue?vue&type=script&lang=js"
export * from "./Set-Mesh.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__